import { racehorse360 } from "@tsg/1st-grpc-web-rh360";
import { useRacehorse360Api } from "hooks/api";

interface PageStateHookReturnValue {
  isLoading: boolean;
  users: racehorse360.IUser[];
  fetchNextPage: () => void;
  isFetchingNextPage: boolean;
  hasNextPage: boolean;
}

const RECORDS_PER_PAGE = 40;

export function usePageState(userInfo: string): PageStateHookReturnValue {
  const { useInfiniteListUsers } = useRacehorse360Api();

  const {
    fetchNextPage,
    isFetchingNextPage,
    hasNextPage,
    isLoading: usersLoading,
    data
  } = useInfiniteListUsers(
    "ALL_USERS",
    {
      query: {
        userInfo: userInfo?.length >= 3 ? userInfo.trim() : undefined
      },
      pagingOptions: {
        maxResults: RECORDS_PER_PAGE
      },
      getOptions: {
        select: [
          "firstName",
          "lastName",
          "email",
          "licenseNumber",
          "phoneNumber"
        ],
        orderBy: ["lastName", "firstName"]
      }
    },
    {}
  );

  const users: racehorse360.IUser[] = data?.pages ? data.pages.flat() : [];

  return {
    fetchNextPage,
    isFetchingNextPage,
    hasNextPage,
    isLoading: usersLoading,
    users
  };
}
